export const LOCATION_DROPDOWN_ID = 'locations-dropdown';
export const OPEN_WIZARD_BTN_ID = 'open-wizard-btn';
export const CHECK_AVAILABILITY_ID = 'check_availability';
export const CLOSE_WIZARD_BTN_ID = 'wizard-close-btn';
export const DESIRED_CAPACITY_INPUT_ID = 'desiredCapacity';
export const DESIRED_CAPACITY_DECREASE_ID = 'desiredCapacityDecrease';
export const DESIRED_CAPACITY_INCREASE_ID = 'desiredCapacityIncrease';
export const WIZARD_NODE_ID = 'wizard';
export const WIZARD_STEP_2_LINK_ID = 'wizard-step-2-link';

export function getLocationDropdown() {
  return document.getElementById(LOCATION_DROPDOWN_ID);
}

export function getSelectedLocation() {
  const locationDropdown = getLocationDropdown();
  if (!locationDropdown) {
    throw new Error('No locations dropdown in DOM');
  }

  const { options, selectedIndex } = locationDropdown;
  return options[selectedIndex];
}

export function getLocationDropdownSelectedId() {
  const locationDropdown = getLocationDropdown();
  return locationDropdown && locationDropdown.value;
}

export function getLocationDropdownSelectedName() {
  const selectedLocation = getSelectedLocation();
  return selectedLocation && selectedLocation.text;
}

export function getDesiredCapacityValue() {
  const desiredCapacityEl = document.getElementById(DESIRED_CAPACITY_INPUT_ID);
  return desiredCapacityEl && desiredCapacityEl.value;
}

export function setDesiredCapacityValue(value) {
  const desiredCapacityEl = document.getElementById(DESIRED_CAPACITY_INPUT_ID);
  if (desiredCapacityEl) {
    desiredCapacityEl.value = Number(value);
  }
}
